import { render, staticRenderFns } from "./ResultHead.vue?vue&type=template&id=fd5d83d8&scoped=true"
import script from "./ResultHead.vue?vue&type=script&lang=js"
export * from "./ResultHead.vue?vue&type=script&lang=js"
import style0 from "./ResultHead.vue?vue&type=style&index=0&id=fd5d83d8&prod&lang=css"
import style1 from "./ResultHead.vue?vue&type=style&index=1&id=fd5d83d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5d83d8",
  null
  
)

export default component.exports